import axios from 'axios'
const api = axios.create({
  baseURL: '/ewapi',
  withCredentials: true,
  timeout: 60000,
  validateStatus: function(status) {
    return status > 0
  }
})

api.interceptors.response.use(
  r => {
    const { data, statusCode, message } = r.data
    if (statusCode === 200) {
      return data
    } else {
      if (r.config.url === '/occ/order/as/ew/client/v1/mobile/order/create' && /^5/.test(r.status)) {
        return Promise.reject({ data, statusCode, message: '订单创建失败 请重新提交' })
      }
      return Promise.reject({ data, statusCode, message })
    }
  },
  error => {
    return Promise.reject(error)
  }
)
export default api
